import styled from 'styled-components'

import { AutomationEntities } from 'shared/types/global'
import Flex from 'shared/ui/Flex'
import Text from 'shared/ui/Text'

import { EntityOption } from '../../types'
import { ReactComponent as AllImage } from './images/all-pages.svg'
import { ReactComponent as CollageImage } from './images/collages.svg'
import { ReactComponent as ProfileImage } from './images/profile.svg'
import { ReactComponent as QuoteImage } from './images/quotes.svg'
import { ReactComponent as RankingImage } from './images/rankings.svg'
import { ReactComponent as ReportImage } from './images/reports.svg'

const ImageWrapper = styled.div<{ $isSelected: boolean }>`
  padding: 4px;
  background-color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.color.brand_02 : theme.color.base.c0};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Option = styled(Flex)`
  cursor: pointer;
  flex-direction: column;
  row-gap: 16px;
  align-items: center;
`

const OPTIONS: {
  label: string
  key: EntityOption
  Image: React.FC
}[] = [
  {
    label: 'All',
    key: 'all',
    Image: AllImage
  },
  {
    label: 'Profiles',
    key: AutomationEntities.profiles,
    Image: ProfileImage
  },
  {
    label: 'Quotes',
    key: AutomationEntities.quotes,
    Image: QuoteImage
  },
  {
    label: 'Collages',
    key: AutomationEntities.collages,
    Image: CollageImage
  },
  {
    label: 'Rankings',
    key: AutomationEntities.rankings,
    Image: RankingImage
  },
  {
    label: 'Reports',
    key: AutomationEntities.reports,
    Image: ReportImage
  }
]

type EntitiesSelectorProps = {
  selectedEntities: EntityOption[]
  onSelectedEntitiesChange: (entities: EntityOption[]) => void
}

const EntitiesSelector: React.FC<EntitiesSelectorProps> = ({
  selectedEntities,
  onSelectedEntitiesChange
}) => {
  const toggleEntity = (entity: EntityOption) => {
    // Removing "all"
    const filteredEntities = selectedEntities.filter(e => e !== 'all')

    if (selectedEntities.includes(entity)) {
      onSelectedEntitiesChange(
        filteredEntities.filter(e => e !== entity)
      )
    } else {
      onSelectedEntitiesChange([...filteredEntities, entity])
    }
  }

  const handleSelectedEntitiesChange = (entity: EntityOption) => {
    if (entity === 'all') {
      return onSelectedEntitiesChange(['all'])
    }

    toggleEntity(entity)
  }

  return (
    <Flex direction="column" rowGap={24}>
      <Text weight={700} size={20} text="Entities" tag="h3" />

      <Flex direction="row" columnGap={16}>
        {OPTIONS.map(option => (
          <Option
            key={option.key}
            onClick={() =>
              handleSelectedEntitiesChange(option.key as EntityOption)
            }
          >
            <ImageWrapper
              $isSelected={selectedEntities.includes(
                option.key as EntityOption
              )}
            >
              <option.Image />
            </ImageWrapper>
            <Text
              tag="span"
              size={14}
              weight={600}
              text={option.label}
            />
          </Option>
        ))}
      </Flex>
    </Flex>
  )
}

export default EntitiesSelector
